module.exports = __webpack_public_path__ + "static/caveats-profits-0ec8d1485eeaa03b769f65c7e5c06759.png";